import React from 'react';
import './Breadcrumbs.scss';
import { BreadcrumbsProps } from './Breadcrumbs.types';

const Breadcrumbs = ({
  id,
  maxLabelSizeLength = 15,
  items,
}: BreadcrumbsProps) => {
  const isLastItem = (index: number) => {
    return index === items.length - 1;
  };

  return (
    <nav id={id} aria-label="breadcrumb">
      <ol className="tfl-breadcrumb">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {!isLastItem(index) ? (
              <li className="tfl-breadcrumb-item">
                <a
                  href={item.href}
                  title={item.title ? item.title : item.label}
                >
                  {item.label.length > maxLabelSizeLength
                    ? `${item.label.substring(0, maxLabelSizeLength)}...`
                    : item.label}
                </a>
              </li>
            ) : (
              <li className="tfl-breadcrumb-item active" aria-current="page">
                {item.label}
              </li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};
export default Breadcrumbs;
